// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-author-button a {
    color: white; 
    background-color: gray; 
    font-weight: bold; 
    padding: 8px 16px;
    text-decoration: none;
    border-radius: 4px;
}
.header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.add-author-button a:hover {
    background-color: darkred; /* Darker background color on hover */
}

.centered-modal {
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-content {
    background-color: white;
    box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);
    padding: 20px;
    border-radius: 8px;
    width: 80%;
    max-width: 600px; 
}

.modal-row {
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.author-image-preview {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    object-fit: cover;
}

.modal-content label {
    margin-bottom: 8px;
}
@media (max-width: 600px) {
    .modal-content {
        width: 90%;
    }
}
/* RichTextEditor.css */

.rich-text-editor-container {
    margin: 20px;
    padding: 20px;
    border: 1px solid #ccc;
    border-radius: 8px;
    background-color: #f9f9f9;
  }
  
  h2 {
    margin-bottom: 10px;
    font-size: 18px;
    font-weight: bold;
  }
  
  .editor-preview {
    margin-top: 20px;
  }
  
  .editor-preview h3 {
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }
  
  .editor-preview div {
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
  }
  `, "",{"version":3,"sources":["webpack://./src/pages/authors/Authors.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,yBAAyB,EAAE,qCAAqC;AACpE;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,uCAAuC;IACvC,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI;QACI,UAAU;IACd;AACJ;AACA,uBAAuB;;AAEvB;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;EACxB","sourcesContent":[".add-author-button a {\n    color: white; \n    background-color: gray; \n    font-weight: bold; \n    padding: 8px 16px;\n    text-decoration: none;\n    border-radius: 4px;\n}\n.header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n.add-author-button a:hover {\n    background-color: darkred; /* Darker background color on hover */\n}\n\n.centered-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.modal-content {\n    background-color: white;\n    box-shadow: 0 0 24px rgba(0, 0, 0, 0.1);\n    padding: 20px;\n    border-radius: 8px;\n    width: 80%;\n    max-width: 600px; \n}\n\n.modal-row {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 10px;\n}\n\n.modal-actions {\n    display: flex;\n    justify-content: flex-end;\n    margin-top: 20px;\n}\n\n.author-image-preview {\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    object-fit: cover;\n}\n\n.modal-content label {\n    margin-bottom: 8px;\n}\n@media (max-width: 600px) {\n    .modal-content {\n        width: 90%;\n    }\n}\n/* RichTextEditor.css */\n\n.rich-text-editor-container {\n    margin: 20px;\n    padding: 20px;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n  }\n  \n  h2 {\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-weight: bold;\n  }\n  \n  .editor-preview {\n    margin-top: 20px;\n  }\n  \n  .editor-preview h3 {\n    margin-bottom: 10px;\n    font-size: 16px;\n    font-weight: bold;\n  }\n  \n  .editor-preview div {\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    background-color: #fff;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
